<template>
  <div class="tekenaar">
    <div
      class="item opdrlistopdrachtnummer"
      style="opacity: 1;min-width: 160px;max-width:200px;"
    >
      <span
        v-if="opdrachts.opdrachtnummermaand"
        class="tekst"
        style="font-weight:600;"
        >CDT.{{ opdrachts.opdrachtnummerjaar }}.{{
          opdrachts.opdrachtnummermaand
        }}.{{ opdrachts.opdrachtnummer }}</span
      >
      <span
        v-if="!opdrachts.opdrachtnummermaand"
        class="tekst"
        style="font-weight:600;"
        >CDT.{{ opdrachts.opdrachtnummerjaar }}.{{
          opdrachts.opdrachtnummer
        }}</span
      >
    </div>
    <div class="item opdrlistbedrijfsnaam" style="min-width: 200px;">
      <span class="tekst">{{ opdrachts.bedrijfsnaam }}</span>
    </div>
    <div class="item opdrlistdisciplines" style="min-width:200px;">
      <span
        class="disciplinee"
        :class="{
          pastel1: opdrachts.disciplines == 'Bouwkunde',
          pastel2: opdrachts.disciplines == 'Werktuigbouwkunde',
          pastel3: opdrachts.disciplines == 'Installatietechniek',
          pastel4: opdrachts.disciplines == 'Elektrotechniek',
          pastel5: opdrachts.disciplines == 'Huisvesting',
          pastel6: opdrachts.disciplines == 'Plattegronden',
          pastel7: opdrachts.disciplines == 'Concepten - 3D Print',
          pastel8: opdrachts.disciplines == 'Brandpreventie',
          pastel9: opdrachts.disciplines == 'Nen2580'
        }"
        >{{ opdrachts.disciplines }}</span
      >
    </div>
    <div class="item opdrliststatus" style="min-width:220px;">
      <span
        v-if="opdrachts.geannuleerd != true && opdrachts.onhold != true"
        class="tekst"
        >{{ opdrachts.status }}</span
      >
      <span
        v-if="opdrachts.geannuleerd == true"
        class="tekst"
        style="color:#F1646C;"
        >Geannuleerd</span
      >
      <span v-if="opdrachts.onhold == true" class="tekst" style="color:#FF9326;"
        >On Hold</span
      >
      <div
        v-if="
          opdrachts.status == 'In behandeling' && opdrachts.geannuleerd != true
        "
        style="width:10px;height:10px;background-color:green;border-radius:100px;display:inline-block;margin-left:5px;"
      ></div>
    </div>
    <div class="item opdrlistaanvraagdatum" style="min-width: 220px;">
      <span class="tekst">{{ aanvraagdatum }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    opdracht: Object
  },
  components: {},
  computed: {
    aanvraagdatum() {
      if (this.opdracht.aanvraagdatum.substr(0, 1) == '"') {
        return this.opdracht.aanvraagdatum.substr(1, 10);
      } else {
        return this.opdracht.aanvraagdatum.substr(0, 10);
      }
    },
    opdrachts() {
      return this.opdracht;
    },
    opdrachtid() {
      return this.opdracht.id;
    },
    inBehandeling() {
      return this.opdrachts.status !== "Nieuw";
    },
    discipliness() {
      let b = [];
      this.tekenaars.disciplines.forEach(element => {
        b.push(element.charAt(0));
      });
      return b;
    }
  }
};
</script>

<style scoped>
.disciplinee {
  background-color: #e4ecfa;
  border-radius: 100px;
  padding: 5px 10px;
  display: inline;
  /* display: flex;
        align-items: center;
        justify-content: center; */
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-right: 7px;
  /* border: 2px solid white; */
}

.circle {
  width: 20px;
  height: 20px;
  background-color: #b8c3d5;
  border-radius: 100px;
}

.voltooid {
  background-color: #3076ea;
}

.tekenaar {
  background-color: #fff;
  padding: 25px;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  font-size: 15px;
  border-bottom: 1px solid #c5d8e3;
  border-left: 1px solid #c5d8e3;
  border-right: 1px solid #c5d8e3;
}

.tekenaar:hover {
  background-color: #ecf3fc;
  /* color: #fff; */
}
.item {
  /* opacity: 0.65; */
  color: #0b1125;
  opacity: 0.8;
  display: flex;
  overflow: hidden;
  align-items: center;
  min-width: 160px;
  width: 25%;
  overflow: visible;
}

.tekst {
  white-space: nowrap;
}

.discipline {
  background-color: #e4ecfa;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: -4px;
  font-size: 11px;
  color: #697a95;
  border: 2px solid white;
}
</style>
